export const dashboards = [
  { id: 'isd', name: 'ISD', path: '/isd', package: '@fleet-os/isd' },
  { id: 'csd', name: 'CSD', path: '/csd', package: '@fleet-os/csd' },
  { id: 'dpt', name: 'DPT', path: '/dpt', package: '@fleet-os/dpt' },
  { id: 'csm', name: 'CSM', path: '/csm', package: '@fleet-os/csm' },
  { id: 'hawkeye', name: 'Hawkeye', path: '/hawkeye', package: '@fleet-os/hawkeye' },
  { id: 'boards', name: 'Engineering Boards', path: '/boards', package: '@fleet-os/eng-boards' },
  { id: 'city-ops', name: 'City Operations', path: '/city-ops', package: '@fleet-os/city-ops' },
  { id: 'process-governance', name: 'Process Governance', path: '/process-governance', package: '@fleet-os/process-governance' },
  { id: 'opal', name: 'Opal', path: '/opal', package: '@fleet-os/opal' },
  { id: 'abs', name: 'ABS Calibration', path: '/abs', package: '@fleet-os/abs-dashboard' },
  { id: 'vms', name: 'Vehicle Management', path: '/vms', package: '@fleet-os/vms' },
  { id: 'ninety', name: 'Ninety Insights', path: '/ninety', package: '@fleet-os/ninety' }
];
